import { FormattedMessage } from "react-intl";

import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import InvoiceFormBucketAttachments from "./InvoiceFormBucketAttachments";
import InvoiceFormOtherAttachments from "./InvoiceFormOtherAttachments";
import "./InvoiceFormBucketAttachmentItem.scss";

interface InvoiceFormAttachmentsProps {
  isLoading: boolean;
  missingAttachmentBuckets: string[];
}

function InvoiceFormAttachments({ isLoading, missingAttachmentBuckets }: InvoiceFormAttachmentsProps) {
  return (
    <div className="invoice-form-attachments">
      <h4 className="invoice-form-attachments__heading">
        <FormattedMessage id="new-request.provider.attachment" defaultMessage="Attachments" />
      </h4>
      {isLoading && (
        <div className="mt-1">
          <LoadingSkeleton rows={1} />
        </div>
      )}
      {!isLoading && (
        <div className="mt-3">
          <InvoiceFormBucketAttachments missingAttachmentBuckets={missingAttachmentBuckets} />
          <div className="invoice-form-attachments__other">
            <InvoiceFormOtherAttachments />
          </div>
        </div>
      )}
    </div>
  );
}

export default InvoiceFormAttachments;
